import { useEffect } from "react";
import Cookies from "js-cookie";

import CloseCircle from "@src/assets/icons/CloseCircle";
import { TypographyH5 } from "@src/components/shared-ui-components/CustomTypography";

import Colors from "@src/constants/Colors";
import { IconWrapper } from "./style";

const LoginFailed = () => {
  useEffect(() => {
    const userError =
      document.cookie
        ?.split("; ")
        ?.find((cookie) => cookie.startsWith("user_error="))
        ?.split("=")?.[1] || "";
    const decodedUserError = decodeURIComponent(userError);
    Cookies.set("userError", decodedUserError);
    Cookies.remove("user_error");

    setTimeout(() => {
      window.close();
    }, 1000);
  }, []);

  return (
    <IconWrapper>
      <CloseCircle color={Colors.primaryred} width="100" height="100" />
      <div style={{ marginTop: 8 }}>
        <TypographyH5>Login Failed</TypographyH5>
      </div>
    </IconWrapper>
  );
};

export default LoginFailed;
